import React from 'react'
import Link from 'next/link'

import Icon from 'components/Icon'
import { Container } from 'modules/marketplace/layout/components/ResponsiveContainers'
import styles from './Breadcrumbs.module.css'

type BreadCrumbItem = {
  label: string
  href?: string
  icon?: string
}

export type BreadcrumbsProps = {
  crumbs: BreadCrumbItem[]
}

const Crumb = ({ href, label, icon }: BreadCrumbItem) => (
  <li className={styles.crumb}>
    {href ? (
      <Link href={href}>
        <a>
          {icon && <Icon kind={icon} size={14} color="currentColor" />}
          {label && label}
        </a>
      </Link>
    ) : (
      <span>
        {icon && <Icon kind={icon} size={14} color="currentColor" />}
        {label && label}
      </span>
    )}
  </li>
)

const Breadcrumbs = ({ crumbs }: BreadcrumbsProps) => (
  <Container className={styles.breadcrumbsContainer}>
    <ul className={styles.breadcrumbs}>
      <Crumb href="/" label="Home" />
      {crumbs.map(crumb => (
        <Crumb key={`crumb-${crumb.label}`} href={crumb.href} label={crumb.label} />
      ))}
    </ul>
  </Container>
)

export default Breadcrumbs
